const BOOK_SECTION_ID = 'book';
const NAVBAR_OFFSET = 76;

export const BOOKING_HREF = `/#${BOOK_SECTION_ID}`;

export function isHomePage() {
  const path = window.location.pathname;
  return path === '/' || path === '';
}

export function scrollToBookSection({ behavior = 'smooth' } = {}) {
  const target = document.getElementById(BOOK_SECTION_ID);
  if (!target) return false;

  const top = target.getBoundingClientRect().top + window.scrollY - NAVBAR_OFFSET;
  window.scrollTo({ top: Math.max(0, top), behavior });
  return true;
}

/** Same behavior as the homepage floating CTA — smooth scroll on home, navigate then scroll on other pages. */
export function handleBookingClick(event) {
  if (!isHomePage()) return;

  event.preventDefault();
  if (window.location.hash !== `#${BOOK_SECTION_ID}`) {
    window.history.pushState(null, '', BOOKING_HREF);
  }
  scrollToBookSection();
}

export function isBookingHref(href) {
  return href === BOOKING_HREF || href === `#${BOOK_SECTION_ID}`;
}

/** Run after landing on the homepage with #book (other routes → home). */
export function scheduleBookHashScroll() {
  if (!isHomePage() || window.location.hash !== `#${BOOK_SECTION_ID}`) return;

  const run = () => scrollToBookSection({ behavior: 'auto' });

  run();
  const t1 = window.setTimeout(run, 100);
  const t2 = window.setTimeout(run, 500);

  return () => {
    window.clearTimeout(t1);
    window.clearTimeout(t2);
  };
}
